import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  baseURL: '/api',
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  // timeout: 1000,
})

// Ensure we always send the newest csrftoken value even if duplicates exist.
// Browsers can retain multiple csrftoken cookies with different Path/Domain.
// Axios reads the first match; we override with the last occurrence which is
// typically the most recently set and expected by the backend.
function getLatestCookie(name) {
  try {
    const all = (document.cookie || '').split(';').map(s => s.trim())
    for (let i = all.length - 1; i >= 0; i -= 1) {
      const kv = all[i]
      if (kv.toLowerCase().startsWith(`${name.toLowerCase()}=`)) {
        const idx = kv.indexOf('=')
        return decodeURIComponent(idx >= 0 ? kv.slice(idx + 1) : '')
      }
    }
  } catch (e) {}
  return null
}

axiosIns.interceptors.request.use(
  config => {
    const method = (config.method || 'get').toLowerCase()
    const unsafe = method === 'post' || method === 'put' || method === 'patch' || method === 'delete'
    if (unsafe) {
      const latest = getLatestCookie('csrftoken')
      if (latest) {
        config.headers = { ...(config.headers || {}), 'X-CSRFToken': latest }
      }
    }
    return config
  },
  error => Promise.reject(error),
)

// Optional client retry for CSRF failures:
// If a request returns 403 (likely CSRF missing/invalid), fetch a fresh
// csrftoken and retry the original request once.
axiosIns.interceptors.response.use(
  response => response,
  async error => {
    const { config, response } = error || {}
    if (!response || !config) return Promise.reject(error)

    const isCsrfFailure = response.status === 403
    const alreadyRetried = config._csrfRetried === true
    const isBootstrapCall = config.__isCsrfBootstrap === true

    if (isCsrfFailure && !alreadyRetried && !isBootstrapCall) {
      try {
        await axiosIns.get('auth/csrf', { __isCsrfBootstrap: true }).catch(() => {})
        const retryCfg = { ...config, _csrfRetried: true }
        return axiosIns.request(retryCfg)
      } catch (e) {
        // fall through to reject below
      }
    }
    return Promise.reject(error)
  },
)

Vue.prototype.$http = axiosIns

export default axiosIns
